import feathers from '@feathersjs/client'
import socketio from '@feathersjs/socketio-client'
import fcAuth from '@feathersjs/authentication-client'
import io from 'socket.io-client/dist/socket.io'
import { eventsSignDocDone, handleNewMultiSign } from './FeathersEvents'
import { invalidateQuery } from './QueryCache'

// const isDev = !(window._env_ && window._env_.NODE_ENV && window._env_.NODE_ENV === 'production')
const API_BASE_URL = window._env_ && window._env_.API_BASE_URL ? window._env_.API_BASE_URL : 'http://localhost:3001'
const UPLOAD_ENV = window._env_ && window._env_.UPLOAD_ENV ? window._env_.UPLOAD_ENV : 'outs'
console.log('window._env_.UPLOAD_ENV: ', window._env_.UPLOAD_ENV)
console.log('UPLOAD_ENV: ', UPLOAD_ENV)

const FC = {
  socketConfig: {
    timeout: 30000,
    pingInterval: 5000,
    pingTimeout: 20000
  },
  socket: io(API_BASE_URL),
  client: feathers(),
  authenticated: false,
  online: false,
  isDev: true,
  connectionHandler: (event) => () => {
    FC.isDev && console.log(`Socket ${event} to ${API_BASE_URL}`)
    FC.online = event === 'connect'
  },
  uploadEnv: UPLOAD_ENV
}

FC.client.configure(socketio(FC.socket, FC.socketConfig))
FC.client.configure(fcAuth({ storage: new fcAuth.MemoryStorage() }))
FC.socket.on('connect', FC.connectionHandler('connect'))
FC.socket.on('disconnect', FC.connectionHandler('disconnect'))

FC.addListeners = () => {
  FC.client.service('signatures').removeListener('patched')
  FC.client.service('multiSignatures').on('patched', () => invalidateQuery(['multiSignatures', 'multiSign']))
  FC.client.service('signatures').on('patched', eventsSignDocDone)
  FC.client.service('signatures').on('created', handleNewMultiSign)
  FC.isDev && console.log('FC Authenticated & Listening for events')
}

FC.stopListeners = () => {
  FC.isDev && FC.socket.removeAllListeners()
  FC.client.service('signatures').removeListener('patched')
  FC.isDev && console.log('FC Stopped listening for events')
}

FC.login = async (credentials) => {
  try {
    const response = await FC.client.authenticate(credentials)
    FC.authenticated = !!response.accessToken
    FC.authenticated && FC.addListeners()
    return response
  } catch (details) {
    FC.error = details
    return false
  }
}

FC.logout = async () => {
  FC.stopListeners()
  FC.client.logout()
  FC.authenticated = false
}

FC.service = (...params) => FC.client.service(...params)

FC.isReady = () => FC.online && FC.authenticated

export { FC }
